export function formatDate(date, format = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
}, locale = 'de-DE') {
  if (!date) {
    return '';
  }

  return new Date(date).toLocaleString(locale, format);
}